export const iconFontAwesomeBuildingsShopLock = (
	<i className="fa-solid fa-shop-lock"></i>
);
